// extracted by mini-css-extract-plugin
export var locationCard = "_gs-0";